import { i18nClient } from 'vrlcm-gui-i18n';
import DOMPurify from 'dompurify';

export const l10n = (key, args) => {
  const localizedString = i18nClient.l10nService.getMessage(key, args);
  try {
    DOMPurify.addHook('afterSanitizeAttributes', node => {
      // set all anchor elements owning target to target=_blank
      if (node.tagName === 'A' && 'target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
      }
    });
    return DOMPurify.sanitize(localizedString);
  } catch {
    return localizedString || key;
  }
};

export const formatDate = (date, pattern) => {
  try {
    return i18nClient.i18nService.formatDate(date, pattern);
  } catch (err) {
    return date?.toString();
  }
};

export const formatNumber = num => {
  try {
    return i18nClient.i18nService.formatNumber(num);
  } catch (err) {
    return '';
  }
};

export const dateFormatters = {
  FULL_DATE: 'fullDate',
  SHORT: 'short',
  FULL: 'full'
};
